import _ from 'underscore';

let BaseViewMixin = {
  initialize(options) {
    if (options.viewData) {
      this.viewData = options.viewData;
    }
  },

  /**
   * Override the default implementation of the serializeData method to expose
   * arbitrary data to the template.
   *
   * @returns {Object}    Serialized data to be exposed to the template
   */
  serializeData() {
    let data = {};

    if (this.model) {
      data.model = this.model.toJSON();
    }

    if (this.collection) {
      data.collection = this.collection.toJSON();
    }

    if (this.viewData) {
      data.viewData = this.viewData;
    }

    return data;
  },
};

export default BaseViewMixin;
